import { z } from 'zod';
import { isoDate } from './common.js';
import { ArrivalStatus, DeploymentStatus } from '../types/enums.js';
export const createDeploymentSchema = z.object({
    workerId: z.string().uuid(),
    projectId: z.string().uuid(),
    startDate: isoDate,
    startTime: z.string().regex(/^\d{2}:\d{2}$/, 'Expected HH:MM').default('07:30'),
    duration: z.string().min(1),
    supervisorId: z.string().uuid().nullable().optional(),
    meet: z.string().nullable().optional(),
    notes: z.string().nullable().optional(),
    requesterId: z.string().uuid().nullable().optional(),
    waMessageSent: z.boolean().default(false),
    status: z.nativeEnum(DeploymentStatus).default(DeploymentStatus.active),
});
export const updateDeploymentSchema = createDeploymentSchema.partial().extend({
    // Explicit end date — lets ops set/correct the exact date a worker finished on
    // site (e.g. fixing a completed record). Overrides the duration-derived end.
    endDate: isoDate.nullable().optional(),
    arrivalStatus: z.nativeEnum(ArrivalStatus).optional(),
    dnaRecordedBy: z.string().nullable().optional(),
    dnaRecordedAt: z.string().datetime({ offset: true }).nullable().optional(),
    dnaNotes: z.string().nullable().optional(),
});
export const deploymentQuerySchema = z.object({
    search: z.string().optional(),
    projectId: z.string().uuid().optional(),
    workerId: z.string().uuid().optional(),
    status: z.nativeEnum(DeploymentStatus).optional(),
    arrivalStatus: z.nativeEnum(ArrivalStatus).optional(),
    startDateFrom: isoDate.optional(),
    startDateTo: isoDate.optional(),
});
export const bulkDeploySchema = z.object({
    projectId: z.string().uuid(),
    workerIds: z.array(z.string().uuid()).min(1),
    startDate: isoDate,
    startTime: z.string().regex(/^\d{2}:\d{2}$/),
    duration: z.string().min(1),
    supervisorId: z.string().uuid().nullable().optional(),
    requesterId: z.string().uuid().nullable().optional(),
    meet: z.string().nullable().optional(),
    notes: z.string().nullable().optional(),
});
export const markDnaSchema = z.object({
    deploymentId: z.string().uuid(),
    scheduledDate: isoDate.optional(),
    scheduledTime: z.string().regex(/^\d{2}:\d{2}$/).optional(),
    recordedBy: z.string().min(1),
    notes: z.string().nullable().optional(),
});
//# sourceMappingURL=deployment.js.map